export default [
  {
    path: '/user/directories/positions',
    name: 'PositionList',
    component: () => import('@/views/Users/Directories/PositionList.vue')
  },
  {
    path: '/user/directories/employments',
    name: 'EmploymentList',
    component: () => import('@/views/Users/Directories/EmploymentList.vue')
  },
  {
    path: '/user/directories/statuses',
    name: 'StatusList',
    component: () => import('@/views/Users/Directories/StatusList.vue')
  },
  {
    path: '/user/directories/schedules',
    name: 'ScheduleList',
    component: () => import('@/views/Users/Directories/ScheduleList.vue')
  }
]
